import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MediaService } from '@klickdata/core/media/src/media.service';
import { MessageSavedComponent } from '@klickdata/core/message';
import { MessageService } from '@klickdata/core/message/src/message.service';
import { switchMap, takeUntil } from 'rxjs/operators';
import { OnDestroyHandler } from '../../onDestroy-handler/onDestroy-handler';
import { FormControl } from '@angular/forms';
import { Media } from '@klickdata/core/media/src/media.model';
@Component({
    selector: 'app-dialog-display-img',
    templateUrl: './dialog-display-img.component.html',
    styleUrls: ['./dialog-display-img.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogDisplayImgComponent extends OnDestroyHandler implements OnInit {
    public favorite = false;
    public imgAccess: FormControl = new FormControl('private');
    constructor(
        public dialogRef: MatDialogRef<DialogDisplayImgComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private mediaService: MediaService,
        private messageService: MessageService,
        private cd: ChangeDetectorRef
    ) {
        super();
    }

    ngOnInit(): void {
        // this.imgAccess.valueChanges
        //     .pipe(
        //         takeUntil(this.destroy),
        //         switchMap((value) => this.mediaService.updateMedia(this.data.id, { visibility: value }))
        //     )
        //     .subscribe((media) => {
        //         this.messageService.openMessage(MessageSavedComponent);
        //     });
    }

    updateFavorite() {
        // this.mediaService
        //     .updateMedia(this.data, { favorite: this.favorite })
        //     .pipe(takeUntil(this.destroy))
        //     .subscribe((media) => {
        //         this.favorite = !this.favorite;
        //         this.messageService.openMessage(MessageSavedComponent, 'Favorite updated');
        //         this.cd.markForCheck();
        //     });
    }
}
